import { messages as msg } from './messages';
var traverse = function (iterable, langInfo, acc) {
    for (var key in iterable) {
        if (iterable.hasOwnProperty(key)) {
            var accumulator = acc.slice();
            accumulator.push(key);
            if (typeof iterable[key] !== 'string') {
                traverse(iterable[key], langInfo, accumulator);
            }
            else {
                var value = iterable[key];
                Object.defineProperty(langInfo, accumulator.join('.'), { value: value });
            }
        }
    }
};
/**
 * Provides mechanism to load language-specific messages for the KendoReact components.
 *
 * @param messages - An iterable object which contains key-value pairs.
 * @param languages - The language to which the messages are associated.
 */
export function loadMessages(messages, language) {
    var langInfo = msg[language] = msg[language] || {};
    traverse(messages, langInfo, []);
}
//# sourceMappingURL=loadMessages.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-intl/dist/es/Localization/loadMessages.js
// module id = 1147
// module chunks = 0